<template>
  <div class="wrap">
    <div class="main">
      <div class="content">
        <span>{{title}}</span>
        <Icon @click="cancel" size="20" type="ios-close-circle-outline" />
      </div>
      <div class="body">
        <div class="desc" v-if="desc">{{desc}}</div>
        <div class="text" v-if="text">{{text}}</div>
      </div>
      <div class="btn-grounp">
        <Button type="text" @click="cancel" v-if="showCancel">取消</Button>
        <Button type="primary" @click="confirm">确认</Button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  data () {
    return {
      title: '这是一个弹窗',
      confirmText: '确定',
      cancelText: '取消',
      desc: '',
      showCancel: true,
      text: ''
    }
  },
  methods: {
    show (cb) {
      typeof cb === 'function' && cb.call(this, this)
      return new Promise(resolve => {
        this.resolve = resolve
      })
    },
    confirm () {
      this.resolve('confirm')
      this.hide()
    },
    cancel () {
      this.resolve('cancel')
      this.hide()
    },
    hide () {
      document.body.removeChild(this.$el)
      this.$destroy()
    }
  }
}

</script>

<style scoped lang="less">
.wrap{
  position: fixed;
  top: 0;
  bottom:0;
  z-index: 9999999999;
  left:0;
  right:0;
  display:flex;
  justify-content: center;
  align-items: center;
  background: rgba(0,0,0,.6);
  .main{
    width: 30%;
    padding: 10px;
    background: #fff;
    border-radius: 5px;
  }
  .body{
    padding: 20px 0;

    .desc{
      font-size: 14px;
      margin-bottom: 10px;
    }

    .text{
      font-weight: bold;
      font-size: 30px;
      color: #000;
      letter-spacing: 2px;
    }
  }
  .content{
    color:#424242;
    font-size: 20px;
    display: flex;
    justify-content: space-between;

  }
  .btn-grounp{
    margin-top: 15px;
    display:flex;
    justify-content: flex-end;
  }
  .btn{
    margin-left: 15px;
    padding: 5px 20px;
    border-radius: 5px;
    font-size: 16px;
    color:#fff;
  }
  .confirm{
    background: lightblue;
  }
  .cancel{
    background: lightcoral;
  }
}

</style>
